export const AUTH_VERSION = 1;

const defaultState = {
    scope: '',
    feature: [],
    version: AUTH_VERSION,
};

const auth = (state = defaultState, action) => {
    const { type, ...user } = action;
    switch (type) {
        case 'INIT_AUTH':
            if (state.version !== AUTH_VERSION || !state.scope) {
                return defaultState;
            }
            return {
                ...state,
                isRefreshing: false,
            };
        case 'REFRESH_USER':
            return {
                ...defaultState,
                ...user,
                expires_at: user.expires_in ? Date.now() + (user.expires_in * 1000) : null,
                isRefreshing: false,
            };
        case 'UPDATE_USER':
            return {
                ...defaultState,
                ...state,
                ...user,
                expires_at: user.expires_in ? Date.now() + (user.expires_in * 1000) : (user.expires_at || state.expires_at),
                isRefreshing: typeof user.isRefreshing !== 'undefined' ? user.isRefreshing : state.isRefreshing,
            };
        case 'SET_AUTH_REFRESHING':
            return {
                ...state,
                isRefreshing: action.status,
            };
        case 'LOGOUT':
            return defaultState;
    }
    return state;
};

export default auth;
